import {FieldProxyConfiguration} from "../advanced-form/field-configuration.interface";
import {FieldProxy} from "../advanced-form/field.proxy";
import {FormProxy} from "../advanced-form/form.proxy";
import {DefaultComparator} from "../comparators/default.comparator";
import {ObjectHelper} from "./object.helper";
import {FormItem} from "../advanced-form/form-item.interface";

export class FormHelper {

    public static async build<
        TValue extends Record<string, any>,
        PValue extends TValue[keyof TValue]
    >(key: string, object: TValue, _formSettings: FieldProxyConfiguration<PValue>[]): Promise<FormProxy<TValue>> {

        const entries = await Promise.all(_formSettings.map(
            async formSetting => {
                let formItemValue = Reflect.get<TValue, keyof TValue>(object, formSetting.key);

                if (ObjectHelper.isPromise(formItemValue)) {
                    formItemValue = await formItemValue;
                }

                const formItem: FormItem<any> = (Array.isArray(formSetting.type) && formSetting.type.length > 0)
                    ? await FormHelper.build(formSetting.key, formItemValue, formSetting.type)
                    : new FieldProxy(
                        formSetting.key,
                        formItemValue,
                        formSetting.comparator ?? new DefaultComparator(),
                        ...(formSetting.validators ?? [])
                    );

                return [
                    formSetting.key,
                    formItem
                ];
            }
        ))

        const fields = Object.fromEntries(entries);

        return new FormProxy<TValue>(key, fields);
    }
}